module.exports = __webpack_public_path__ + "static/media/dayCare.26bcbaad.svg";